import { useEffect, useState } from 'react';

import './NoticeBoard.css';
import { fetchNoticesData } from '../../utils/fetchNoticesData';

import { Notice } from './noticeTypes';

const DRIVE_FILE_ID = '1REYGB7ofQPvrInv8f-ozfHA0KN3nF6sl';

// Add prop type
interface NoticeBoardProps {
  onDisplayChange?: (isDisplayed: boolean) => void;
}

const NoticeBoard = ({ onDisplayChange }: NoticeBoardProps) => {
  const [activeNotices, setActiveNotices] = useState<Notice[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadNotices = async () => {
      try {
        setIsLoading(true);
        const data = await fetchNoticesData(DRIVE_FILE_ID);
        const now = new Date();
        const validNotices = data.notices.filter(
          (notice) => new Date(notice.endDate) > now
        );
        setActiveNotices(validNotices);
        if (onDisplayChange) {
          onDisplayChange(validNotices.length > 0);
        }
      } catch (error) {
        console.error('Failed to load notices:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadNotices();
  }, [onDisplayChange]);

  if (isLoading) {
    return null;
  }

  if (activeNotices.length === 0) {
    return null;
  }

  return (
    <div className="notice-board mb-2">
      <div className="notice-board-header">Notice Board</div>
      <div className="marquee-container">
        <div className="marquee">
          {activeNotices.map((notice) => (
            <div className="notice" key={notice.id}>
              {notice.message}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NoticeBoard;
